// extracted by mini-css-extract-plugin
export default {"title":"styles_title__X0NCR","optional":"styles_optional__WwHwY"};